const URL_SERVICE = 'https://backend.homolog.assembleiacoop.coop.br';
export default URL_SERVICE;
